import React from "react";

const FACEBOOK = [
  <p>
    Built highly data-driven async searchable hierarchical selector using React,
    Laminar (like Redux), Relay, GraphQL
  </p>,
  <p>
    Implemented component onto multiple product web pages and developed their
    GraphQL endpoints in PHP
  </p>,
  <p>
    Fixed bugs on and modernized deprecated React components and PHP files on
    team’s codebase
  </p>,
];

const PANW = [
  <p>
    Implemented mock log generation with C and Docker on internal firewall
    simulator and send them to a data lake
  </p>,
  <p>
    Automated the creation of C header files through developing a Python script
    that parses log schematic files
  </p>,
  <p>
    Designed and developed a Flask architectural diagram app of Cortex Data Lake
    to diagnose its layer/segments
  </p>,
];

const CHARLESSCHWAB = [
  <p>
    Developed the “change your password” webpage for the Charles Schwab website
    using Angular
  </p>,
  <p>
    Led and collaborated the development of “risk-based authentication” webpage
    that verifies the identity of users
  </p>,
  <p>
    Utilized full-stack knowledge through use of Angular, Jasmine, MongoDB, and
    Karma unit testing
  </p>,
];

const ANTHROPOLOGY = [
  <p>
    Created a full-stack platform that acts as a forum to connect
    anthropologists around the world{" "}
  </p>,
  <p>
    Coordinated with a multi-disciplinary group of professors and students to
    delegate the library’s projects
  </p>,
];

export { FACEBOOK, PANW, CHARLESSCHWAB, ANTHROPOLOGY };
